import React, {useState,useEffect,useContext } from "react"
import FlightDealsCards from "../components/FlightDealsCards"
import LocationWidget from "../components/LocationCarousel"
import ExpandableContent from "../components/ExpandableContent"
import InternalLinkingBlock from "../components/InternalLinkingBlock"
import FAQ from "../components/FAQ"
import FaqAccordion from "../components/FaqAccordion"
import CarouselWrapper from "../components/CarouselWrapper"
import LinkBlock from '../components/LinkBlockComponent'
import Layout from "../components/LayoutV2"
import PopularCities from "../components/popularCities"
import Event from "../components/Event"
import ActivitiesCard from "../components/PopularActivitiesCard"
import * as Fn from "../functions"
import moment from "moment"
import LazyLoad from 'react-lazyload';
import locationsData from "../data/location"
import cityListData from "../data/cityListFirestore"
import { getCookie } from "@airasia/phoenix-widgets/widgets/FlightSearchWidget/utils"
import _ from "lodash"
import ReactMarkdown from 'react-markdown'
import MaintitleDesc from "../components/MaintitleDesc"
import PhoenixUtil from "../components/PhoenixUtilities/utilities"


const SecondPage = props => {
  var Data = props.pageContext.data;
  const lang = _.get(props, "pageContext.lang", "en-gb");
  var [GlobalState, setGlobalState] = useState(() => {
    if(typeof(window) !== "undefined"){
      return {
        currency: getCookie("uhfCurrency") || localStorage.getItem("userSelectedCurrency") || "",
        lang: "en/gb"
      };
    }
  })

  // console.log("page_data:", Data)
 //Ads
 var [width,Setwidth] = useState()
  useEffect(() =>Fn.DynamicWidth(Setwidth),[GlobalState] );
  useEffect(()=>{Fn.useDfpSlot(width,lang.split("-")[0],null,Data.routes.toLowerCase())},[width])
 //end ads
  var [URLs,SetURLs]=useState([])
  var [StationCode,SetStationCode]=useState([])
  var [InterprojectInternalLinkingData,SetInterprojectInternalLinkingData]=useState([])
  var [CardData,SetCardData]=useState([])
  var [Airport,SetAirport]=useState(null)
  var today = moment().format("YYYY-MM-DD")
  var lists=[]
  var [internalLinkingDataTeam,SetInternalLinkingDataTeam]=useState([])
  var [topAirportInternalLinking,SetTopAirportInternalLinking]=useState([])
  
  useEffect(() => {
    fetch(`https://sch.apiairasia.com/seohierarchy/en-gb/file.json`)
    .then(response => response.json())
    .then((data) => {
      var result= data
      if(data.length>1)
      {
        SetStationCode(
          result.map((x,index) => {
            return {
              ParentRegionId: x.ParentRegionId,
              RegionId: x.RegionId,
              RegionName: x.RegionName,
              RegionNameAbbr: x.RegionNameAbbr,
              RegionType: x.RegionType
            }
          })
        )
        
        if(StationCode.length>0){
          var GetRegion = StationCode.filter(function(sc) {
            return (sc.RegionName == Data.routes && sc.RegionType == "City")||(sc.RegionName == Data.routes && sc.RegionType == "State");
          }); 
             
          if (GetRegion.length>0){  
            var RegId = GetRegion[0].RegionId
            
            var GetfromParentRegion = StationCode.filter(function(x) {
              return x.ParentRegionId == RegId.toString()
            });
            var StatCode = GetfromParentRegion[0].RegionNameAbbr
          
            if(StatCode)
            {
              SetAirport(StatCode.toString())
              SetURLsList(StatCode.toString())
            }
          }
        }
        else
          SetAirport("")
      }
      })
  }, [Airport]) 

  function SetURLsList(Airport){
    fetch(`https://sch.apiairasia.com/destination/${Airport.toLowerCase()}/file.json`)
        .then(response => response.json())
        .then(data =>
          SetDatafromURLs(
            []
              .concat(...Object.values(data).map(x => Object.keys(x)))
              .map(x => {
                return {
                 link: "https://k.apiairasia.com/availabledates/api/v1/singleprice/0/0/MYR/"+ x +"/"+Airport.toString()+"/"+today+"/1/5"
                }
              }).filter(x=>x!=null && x!=="AMD" && x!=="IXA" && x!=="KJT")  //there is no "AMD|IXA|KJT" info on the seohierarchy API
          ),
        )
  }
  var changedList =[]
  var image = 0;

  function SetDatafromURLs(URLList){
    SetURLs(URLList)
    Promise.all(URLList.slice(0,10).map((request) => {
      return fetch(request.link).then((response) => {
          return response.json();
      }).then((data) => {
        changedList = [].concat(data);
        changedList.map((x,index)=> {
          var firstData = Object.keys(x)
          var input = firstData.toString().replace("|","")
          var secondData = input.length>2? Object.entries(Object.values(x)[0]).toString():null
          var output = input.length>2? secondData.split(","):null
          var item = null
          var img = Data.routes.replace(" ","-").toLowerCase()

          if (input.length>2 && firstData.toString()!="Service"){
            var DepCode = input.match(/.{1,3}/g)[0]
            var GetRegion = StationCode.filter(function(sc) {
              return (sc.RegionNameAbbr == DepCode && sc.RegionType == "City")})
            var RegionName = GetRegion.map((x,index)=>{
              return x.RegionName})

            item={
              departure:RegionName.toString(),
              destination:Data.routes.toString(),
              departurecode: input.match(/.{1,3}/g)[0],
              destinationcode: input.match(/.{1,3}/g)[1],
              date : moment(output[0]).format("MMMM D, YYYY"),
              currency : input.match(/.{1,3}/g)[2],
              price: output[1],
              image: img?img.trim()+"_region_"+(image+1)+".jpg":"bangkok_region_6.jpg"
            }
          }
          if(item){
            image++
            lists.push(item)
            SetCardData(lists.slice(0, 5))
          }    
        })
        return data 
      })
    })
    )
  }

  var [DataPopActivities,SetPopActivities]=useState([])

  // useEffect(()=> {
  //   if(Airport){
  //     //console.log("Airport:", Airport)
  //   fetch(`https://cdn.vidi.co/api/emarsys/en-gb/offers/${Airport.toString()}`)
  //   .then(response => response.json())
  //   .then((data) => {
  //     //console.log("data:", data)
  //     if (data.offers.length>0){
  //       var result= Object.entries(Object.values(data.offers[0])[1])
  //       //console.log("result:", result)
  //       var day =parseInt(moment(new Date()).format("D"))
  //       if(result.length>1)
  //       {
  //         SetPopActivities(
  //           result.map((x,index) => {
  //             var getPrice = x[1].curr.filter(function(x) { return x.currency_code == GlobalState.currency.toString()})
  //             return {
  //               offerId: x[1].offer_id,
  //               title: x[1].text,
  //               description: x[1].description,
  //               date: moment(new Date()).format("MMMM D, YYYY"),
  //               image: x[1].imageurl,
  //               link: x[1].offer_url,
  //               text: x[1].text,
  //               price: getPrice[0].currency_code+" "+ getPrice[0].price
  //             }
  //           })
  //         )
  //       }
  //     }
  //   })
  //   }
  // },[Airport, GlobalState])

//   useEffect(() => {
//   //get location detail from location.json file
//   let getLocationDetail = locationsData.filter(x => x !== null && x.name.toLowerCase() === Data.routes.toLowerCase())
//   let type 

//   if(getLocationDetail.length>1){
//     getLocationDetail = getLocationDetail.filter(x => x !== null && x.type.toLowerCase() === "city")
//     type = getLocationDetail.map(a => a.type).toString();
//   } 
//   else type = getLocationDetail.map(a => a.type).toString();

//   let HotelsInternalLinking = null
//   let currentDestination = Data.routes.replace(" ","-").toLowerCase()
//   //set all-hotels internal linking
//   if(type)
//   {
//     if(type=="country")HotelsInternalLinking = `https://www.airasia.com/all-hotels/${currentDestination}/`
//     if(type=="state"){
//       let countryName = getLocationDetail.map(a => a.countryName).toString();
//       HotelsInternalLinking = `https://www.airasia.com/all-hotels/${countryName.replace(" ","-").toLowerCase()}/${currentDestination}/`
//     }
//     if(type=="city"){
//       let countryName = getLocationDetail.map(a => a.countryName).toString();
//       let stateName = getLocationDetail.map(a => a.stateName).toString();
//       HotelsInternalLinking = `https://www.airasia.com/all-hotels/${countryName.replace(" ","-").toLowerCase()}/${stateName.replace(" ","-").toLowerCase()}/${currentDestination}/`
//     }
//   // }
//     fetchTheUrl(HotelsInternalLinking) 

//     //============================================================================================================================================================================
//     //Generate Internal Linking from Data Team in Firestore
//     var InternalLinkingDataTeam = require(`../data/InternalLinkingDataTeam/thailand`);
//     //For Country - Thailand
//     if (Data.url==="/thailand"){
//       let internalLinking = []
//       for (var i = 0; i < InternalLinkingDataTeam.length; i++) {
//         var data = InternalLinkingDataTeam[i]
//         if(data.docUrl == Data.URL) internalLinking.push(data)
//       }
//       if (internalLinking.length) {
//         var dataWithoutTopCityRoute = internalLinking.filter(x=> x.docName !=="documentTopCityRouteOrigin" &&  x.docName !=="documentTopCityRouteDest")
//         var dataTopCityRoute = internalLinking.filter(x=> x.docName !=="documentTopCities" &&  x.docName !=="documentTopStates" &&  x.docName !=="documentTopAirports")
    
//         // set Top Cities data
//         let topCitiesInternalLinking = []
//         var topCities = dataWithoutTopCityRoute.filter(doc=> doc.docName =="documentTopCities")
//         var topCitiesResultDomRecent = Object.entries(Object.values(topCities[0].docData)[1]) //Dom_recent

//         topCitiesResultDomRecent.map((x,index) => {
//           var city = Object.values(x)[0]
//           var link= Object.values(x)[1].Link
//           var rank= Object.values(x)[1].Rank
//           var image = city.replace(" ","-").toLowerCase()
//           var data = {
//             city: city,
//             image: `/medium/${image.replace(" ","-")}_region_2.jpg`,
//             rank: rank,
//             link: {
//               href: link,
//               title: ""
//             }
//           }
//           topCitiesInternalLinking.push(data)
//         })

//         topCitiesInternalLinking = topCitiesInternalLinking.sort(
//           (a, b) =>
//             parseFloat(a.rank) -
//             parseFloat(b.rank)
//         )
//         // SetTopCitiesInternalLinking(topCitiesInternalLinking) 
//         Data.popular_cities.cards = topCitiesInternalLinking
        
//         // set Top States data
//         let topStateInternalLinking = []
//         var topStates = dataWithoutTopCityRoute.filter(doc=> doc.docName =="documentTopStates")
//         var topStatesResultDomRecent = Object.entries(Object.values(topStates[0].docData)[1]) //Dom_recent
  
//         topStatesResultDomRecent.map((x,index) => {
//           var city = Object.values(x)[0]
//           var link= Object.values(x)[1].Link
//           var rank= Object.values(x)[1].Rank
//           var data = {
//             title: `Flights to ${city}`,
//             href: link,
//             rank: rank
//           }
//           topStateInternalLinking.push(data)
//         })
  
//         topStateInternalLinking = topStateInternalLinking.sort(
//           (a, b) =>
//             parseFloat(a.rank) -
//             parseFloat(b.rank)
//         )
    
//         Data.flights[5].link=topStateInternalLinking

//           // set Top Airport data
//           let topAirportInternalLinking = []
//           var topAirports = dataWithoutTopCityRoute.filter(doc=> doc.docName =="documentTopAirports")
//           var topAirportsResultDomRecent = Object.entries(Object.values(topAirports[0].docData)[1]) //Dom_recent
    
//           topAirportsResultDomRecent.map((x,index) => {
//             var airportName = Object.values(x)[0]
//             var link= Object.values(x)[1].Link
//             var rank= Object.values(x)[1].Rank
//             var data = {
//               title: `${airportName} Flights`,
//               href: link,
//               rank: rank
//             }
//             topAirportInternalLinking.push(data)
//           })
    
//           topAirportInternalLinking = topAirportInternalLinking.sort(
//             (a, b) =>
//               parseFloat(a.rank) -
//               parseFloat(b.rank)
//           )
//           var dataAirports = [{
//             title: `Adventure Awaits with Plane Tickets to Thailand Airports`,
//             description: "A traveller's peace of mind starts with their budget, and AirAsia’s airfare to Thailand can certainly help. Next is finding the Thailand airport location that is most convenient for your travel needs. Compare all of your Thailand flight deal options by navigating through the available airport locations in Thailand listed below. Discovering the world starts with a single ticket booking.",
//             link:[...topAirportInternalLinking]
//           }]
//           SetTopAirportInternalLinking(dataAirports)    
//           if(topAirportInternalLinking.length) Data.flights[2].link = topAirportInternalLinking

//           //set Top City Route Destination data
//           let topCityRouteDestLinking = []
//           var topCityRouteDest = dataTopCityRoute.filter(doc=> doc.docName =="documentTopCityRouteDest")
//           var topCityRouteDestDomRecent = topCityRouteDest[0].docData.Dom_Recent ////Dom_recent

//           for (var i = 0; i < 20; i++) {
//             var rowData = topCityRouteDestDomRecent[i]
//             if(rowData){
//               var destCity = rowData.DestinationCity
//               var originCity = rowData.OriginCity
//               var link= rowData.RouteLink
//               var rank= rowData.RecentDomCityRouteRanking
//               var data = {
//                 title: `${originCity} to ${destCity} Flights`,
//                 href: link,
//                 rank: rank
//               }
//               topCityRouteDestLinking.push(data)
//             }
//           }
    
//           topCityRouteDestLinking = topCityRouteDestLinking.sort(
//             (a, b) =>
//               parseFloat(a.rank) -
//               parseFloat(b.rank)
//           )  
//           Data.flights[0].link=topCityRouteDestLinking

//           //set Top City Route Origin data
//           let topCityRouteOriginLinking = []
//           var topCityRouteOrigin = dataTopCityRoute.filter(doc=> doc.docName =="documentTopCityRouteOrigin")
//           var topCityRouteOriginDomRecent = topCityRouteOrigin[0].docData.Dom_Recent ////Dom_recent
  
//           for (var i = 0; i < 20; i++) {
//             var rowData = topCityRouteOriginDomRecent[i]
//             if(rowData){
//               var destCity = rowData.DestinationCity
//               var originCity = rowData.OriginCity
//               var link= rowData.RouteLink
//               var rank= rowData.RecentDomCityRouteRanking
//               var data = {
//                 title: `${originCity} to ${destCity} Flights`,
//                 href: link,
//                 rank: rank
//               }
//               topCityRouteOriginLinking.push(data)
//             }
//           }
    
//           topCityRouteOriginLinking = topCityRouteOriginLinking.sort(
//             (a, b) =>
//               parseFloat(a.rank) -
//               parseFloat(b.rank)
//           )
//           Data.flights[1].link=topCityRouteOriginLinking
//         }
//       }

//     //For City and State in Thailand
//     if (props.pageContext.internalLinking && Data.url!=="/thailand"){
//       let internalLinking = []

//       for (var i = 0; i < InternalLinkingDataTeam.length; i++) {
//         var data = InternalLinkingDataTeam[i]
//         if(data.docUrl == Data.URL) internalLinking.push(data)
//       }
//       if (internalLinking.length) {
//         if(internalLinking.length){
//         let topCityRouteOrigin = []
//         let topCityRouteDest = []

//         let topCityRouteforOrigin = internalLinking[0].docData.RouteOrigin.Dom_Recent
//         let topCityRouteforDest = internalLinking[0].docData.RouteDestination.Dom_Recent
//         for (var i = 0; i < 20; i++) {
//           var rowData = topCityRouteforOrigin[i]
//           if(rowData){
//             var destCity = rowData.DestinationCity
//             var originCity = rowData.OriginCity
//             var link= rowData.RouteLink
//             var rank= rowData.OriRecentDomCityRanking
//             var data = {
//               title: `${originCity} to ${destCity} Flights`,
//               href: link,
//               rank: rank
//             }
//             topCityRouteOrigin.push(data)
//           }
//           else i=10
//         }
//         for (var i = 0; i < 20; i++) {
//           var rowData = topCityRouteforDest[i]
//           if(rowData){
//             var destCity = rowData.DestinationCity
//             var originCity = rowData.OriginCity
//             var link= rowData.RouteLink
//             var rank= rowData.DestRecentDomCityRanking
//             var data = {
//               title: `${originCity} to ${destCity} Flights`,
//               href: link,
//               rank: rank
//             }
//             topCityRouteDest.push(data)
//           }
//           else i=10
//         }
//         if(Data.flights.length>2){
//           if(topCityRouteOrigin.length) Data.flights[0].link = topCityRouteDest
//           if(topCityRouteDest.length) Data.flights[1].link = topCityRouteOrigin
//         }
//       }
//       }
//     }
//     //============================================================================================================================================================================
//   }
// }, [])
  //to fetch all-hotels URL is exists or not
  function fetchTheUrl(URL){
    fetch(URL)
    .then((response) => {
      if(response.status==200){
        var data = [{
          title: `More to Explore for ${Data.routes}`,
          description: "",
          link:[
            {
              title: `Hotels in ${Data.routes}`,
              href: URL
            },
            {
              title:"Promotions",
              href: "https://www.airasia.com/promotions/"
            },
        ]
        }]
        SetInterprojectInternalLinkingData(data)
      }
      else{
        InterprojectInternalLinkingData = [{
          title: `More to Explore for ${Data.routes}`,
          description: "",
          link:[
            {
              title:"Promotions",
              href: "https://www.airasia.com/promotions/"
            },
        ]
        }]
        SetInterprojectInternalLinkingData(data)
      }
      response.json()})
    .then((findresponse)=>{
      //console.log("findresponse.url",findresponse)
    })

  }

  // const isChinaDomain = PhoenixUtil.isChinaDomainName()

  return (
    <Fn.GlobalContext.Provider
      value={{ state: GlobalState, updateState: setGlobalState }}
    >
      <Layout
        breadCrumbs={Data.breadcrumbs}
        routes={Data.routes}
        hero={Data.hero}
        heroImages={_.get(Data, 'hero_images', {})}
        meta={Data.meta}
        url={Data.URL}
        head={Data.head}
        lang={lang}
        isMOVE={_.get(Data, 'isMOVE', false)}
        currency={_.get(
          GlobalState,
          "currency",
          ""
        )} /* api={props.pageContext.api} */
      >
        {Data.About ? <ExpandableContent {...Data.About} /> : null}
        
        <MaintitleDesc {...Data.flight_deals} isMarkdown />
        {
          (!_.includes(Data.URL, "campaign") && !_.includes(Data.URL, "airline")) ? (
            <LazyLoad height={200} placeholder={<p>Loading...</p>}>
              {CardData.length ? <FlightDealsCards data={CardData} /> : null}
              {CardData.length < 1 && Data.popular_cities ? (
                <LocationWidget data={Data.popular_cities.cards} />
              ) : null}
            </LazyLoad>
          ) : null
        }
        
        {internalLinkingDataTeam && Data.url === "/thailand"
          ? internalLinkingDataTeam.map((x, index) => (
              <LinkBlock key={"InternalLinkingDataTeam" + index} {...x} />
            ))
          : null}


        {Data?.flights?.slice(0, 1).map((x, index) => (
          <LinkBlock key={"destinationFlight" + index} {...x} isMarkdown />
        ))}
        {_.has(Data, 'howtobook') && <Event {...Data.howtobook} />}
        {/* {!isChinaDomain && <div id="div-gpt-ad-1586342250790-0"></div>} */}
        {Data.popular_cities ? (
          <PopularCities isAirlineFacility={_.includes(Data.URL, "airline")} {...Data.popular_cities} />
        ) : null}
        {Data?.flights?.slice(1).map((x, index) => (
          <LinkBlock key={"popularCities" + index} {...x} />
        ))}
        {
          Data?.additional_content?.map((x,i)=>(<MaintitleDesc key={"additionalContent" + i} {...x} isMarkdown />))
        }
        <ExpandableContent {...Fn.getDateProperizedContent(Data.things_to_do, lang)} />
        {/* {Data.things_to_do ? (
          <CarouselWrapper data={DataPopActivities} child={ActivitiesCard} />
        ) : null} */}
        
        
        {/* <FAQ {...Fn.getDateProperizedContent(Data.faq, lang)} /> */}
        <FaqAccordion {...Fn.getDateProperizedContent(Data.faq, lang)} />
        {/* {!isChinaDomain && <div
          id="div-gpt-ad-1586342250790-1"
          style={{ marginBottom: "1rem" }}
        ></div>} */}
        {InterprojectInternalLinkingData
          ? InterprojectInternalLinkingData.map((x, index) => (
              <LinkBlock
                key={"InterprojectInternalLinkingData" + index}
                {...x}
              />
            ))
          : null}
        <InternalLinkingBlock linkObjects={Data.popular_destinations} />
      </Layout>
    </Fn.GlobalContext.Provider>
  )
}
export default SecondPage


